import { useState, useEffect } from "react";
import { FlowService } from "../../../../service/FlowService";
import { UserService } from "../../../../service/UserService";
import { Flows } from "../../../../util/Types/Folder";
import { useDebounceEffect } from "../../../../util/useDebounceEffect";
import { SearchItemType, SpaceOption } from "../types";
import { getItemType, getSpaceName } from "./searchUtils";

export interface SearchResult {
  id: string;
  name: string;
  type: SearchItemType;
  spaceName: string;
  isForm: boolean;
}

export const useSearch = (searchValue: string) => {
  const [searchResults, setSearchResults] = useState<SearchResult[]>([]);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [spaces, setSpaces] = useState<SpaceOption[]>([]);

  useEffect(() => {
    const loadSpaces = async () => {
      try {
        const { data } = await UserService.getSpaces();
        setSpaces(data || []);
      } catch (error) {
        console.error("Failed to load spaces:", error);
      }
    };
    loadSpaces();
  }, []);

  useDebounceEffect(
    () => {
      const searchFlows = async () => {
        if (!searchValue.trim()) {
          setSearchResults([]);
          return;
        }
        try {
          setIsSearchLoading(true);
          const { data } = await FlowService.searchFlow(searchValue);
          const mappedResults = data.map((item: Flows) => ({
            id: item.id,
            name: item.name,
            isForm: item.isForm || false,
            type: getItemType(item),
            spaceName: getSpaceName(item, spaces),
          }));
          setSearchResults(mappedResults);
        } catch (error) {
          console.error("Search error:", error);
          setSearchResults([]);
        } finally {
          setIsSearchLoading(false);
        }
      };

      searchFlows();
    },
    [searchValue, spaces],
    500,
  );

  return {
    searchResults,
    isSearchLoading,
  };
};
